import React, { memo, ReactChild, useState } from 'react';
import {
  DotElement as BaseDotElement,
  commonDot as BaseCommonDot,
  DropshippingDotTypes,
} from '@ali/dsfe-dot-element-react';
import { getUserType } from '@ali/ncom-hugo2-ds-user-type';
import dotSceneNameMap from './dotSceneNameMap';

const commonDot = (props: {
  eventType?: 'clk' | 'exp'; // 曝光还是点击，默认值为clk
  userType?: DropshippingDotTypes.userTypeKeys; // 默认为saas链路用户
  goldKey?: string; //  自定义黄金令箭key,  默认值为 /sc.dser.saas
  params: {
    scene: string;
    [key: string]: string | number | undefined;
  }; // 打点业务参数
  actionType?: DropshippingDotTypes.importanceActionKeys; // 关键行为 会从importanceActionNameMap提取关键行为声明
}) => {
  const {
    params: { scene, action, ...others },
    ...otherProps
  } = props;

  const newParams: DropshippingDotTypes.logParamsObjectType = {
    ...props.params,
    sceneName: (others.sceneName || scene).toString(),
  };
  newParams.actionAndResult = newParams.actionAndResult || action?.toString() || '';

  getUserType().then((_userType) => {
    BaseCommonDot({
      ...otherProps,
      params: newParams,
      userType: _userType,
    });
  });
};

const DotElement = memo(
  (props: {
    dotType?: 'all' | 'clk' | 'exp'; // 默认值是all, 直接进行曝光和点击上报
    dotParams: {
      scene: string; //  会当成spmC位
      sceneName?: string; //  会当成spmC位
      action?: string;
      actionAndResult?: string;
      pos?: string | number; //  会当成spmD位
      [key: string]: string | number | undefined;
    };
    userType?: 'isv' | 'saas'; // 默认为saas链路用户
    actionType?: DropshippingDotTypes.importanceActionKeys; // 关键行为 会从importanceActionNameMap提取关键行为声明
    expTime?: number; // 精确曝光的时间间隔, 默认值500ms
    goldKey?: string; // 自定义黄金令箭key,  默认值为 /sc.dser.saas, 如果有关键行为 此值内置
    onClick?: (event?: MouseEvent) => void; // 点击回调方法
    onAppear?: (event?: MouseEvent) => void; // 曝光回调方法
    elementTag?: keyof HTMLElementTagNameMap; // 元素标签类型(htmlTag)，小写，默认为div, 可以

    // 跳转页面url, 程序会自动补全spm参数
    url?: string;

    // 其它html标准属性配置，
    target?: '_self' | '_blank'; // 与url关联验证
    title?: string;
    // 通用react组件属性配置
    style?: Partial<CSSStyleDeclaration>;
    children?: ReactChild | ReactChild[];
    className?: string;
    [key: string]: any;
  }) => {
    const { dotParams, ...others } = props;
    // 兼容逻辑处理
    const newDotParams: DropshippingDotTypes.logParamsObjectType = {
      sceneName: '',
      ...dotParams,
    };
    newDotParams.actionAndResult =
      newDotParams.actionAndResult || dotParams.action?.toString() || '';
    newDotParams.sceneName = newDotParams.sceneName || dotParams.scene.toString();

    const [userType, setUserType] = useState(window.__dsUserType);
    getUserType().then((_userType) => {
      setUserType(_userType);
    });
    return <BaseDotElement {...others} dotParams={newDotParams} userType={userType} />;
  },
);

export { DotElement, commonDot, dotSceneNameMap };
